import { OFFSET_SCROLL, SCROLL_SPEED } from '../utils/constants';

const $ = jQuery;
const $window = $(window);
const $htmlBody = $('html, body');

const jumpmarkAnchorActiveClass = 'jumpmark-menu__link--active';
const jumpmarkAnchorClass = 'jumpmark-menu__link';

const $jumpmarkMenu = $('.jumpmark-menu');
const $jumpmarkMenuContainer = $('.jumpmark-menu__container');
const $jumpmarkAnchors = $(`.${jumpmarkAnchorClass}`);

const $jumpmarkSections = $('.jumpmark-menu__section');

const scrollingOffset = OFFSET_SCROLL;
const justifyOffset = 10;

// @todo wait for Patrick to approve refactoring and rewrite to vanilla
// but should be working rn 🤞

function getActiveSection() {
  const windowScrollTop = $(window).scrollTop();
  const jumpmarkContainerMarginTop = parseInt(
    $('.jumpmark-menu__container').css('margin-top'),
  );
  let activeSectionId = null;
  let closestSection = null;
  let closestDistance = Infinity;

  $jumpmarkSections.each(function (index, section) {
    const sectionOffsetTop =
      $(section).offset().top +
      Math.abs(jumpmarkContainerMarginTop) -
      scrollingOffset -
      justifyOffset;
    const sectionOffsetBottom = sectionOffsetTop + $(section).height();

    if (
      windowScrollTop >= sectionOffsetTop - 10 &&
      windowScrollTop < sectionOffsetBottom
    ) {
      activeSectionId = $(section).attr('id');
    } else {
      const distance = Math.abs(windowScrollTop - sectionOffsetTop);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = $(section);
      }
    }
  });

  return activeSectionId || closestSection.attr('id');
}

function setActiveJumpmark(key) {
  const $activeAnchor = $(`.${jumpmarkAnchorClass}[href="#${key}"]`);
  if (!$activeAnchor.hasClass(jumpmarkAnchorActiveClass)) {
    $jumpmarkAnchors.removeClass(jumpmarkAnchorActiveClass);
    $activeAnchor.addClass(jumpmarkAnchorActiveClass);
  }
}

const scrollSpy = () => {
  const currentSection = getActiveSection();
  setActiveJumpmark(currentSection);
};

function enableSmoothScrollingAnchors() {
  $jumpmarkAnchors.on('click', (e) => {
    e.preventDefault();

    const target = e.currentTarget.hash;
    const $target = $(target);

    // @todo we can reuse the smooth scroll function
    $htmlBody
      .stop()
      .animate(
        { scrollTop: $target.offset().top - scrollingOffset },
        SCROLL_SPEED,
      );
  });
}

function justifyStickyMenu() {
  const jumpmarkMenuItemHeight = $(`.${jumpmarkAnchorClass}`).not('.button')[0]
    .offsetHeight;

  if (!$('body').hasClass('page-node-type-products-detail')) {
    $jumpmarkMenuContainer.css({
      'margin-top': `${jumpmarkMenuItemHeight * -1}px`,
      height: `calc(100% + ${jumpmarkMenuItemHeight}px)`,
    });
  }
}

if ($jumpmarkMenu.length > 0) {
  justifyStickyMenu();
  enableSmoothScrollingAnchors();
  $window.scroll(scrollSpy);
}

// scroll to hash if coming from another page
$(document).ready(function onReady() {
  if (window.location.hash) {
    const { hash } = window.location;
    // exclude funny Google links
    if (hash.startsWith('#:~')) return;

    const $hash = $(hash);

    if ($hash.length > 0) {
      $htmlBody
        .stop()
        .animate(
          { scrollTop: $hash.offset().top - scrollingOffset },
          SCROLL_SPEED,
        );
    }
  }
});
